module.exports = __webpack_public_path__ + "img/BLCA_TMKI67.5e958e98.png";